export default defineNuxtRouteMiddleware(() => {
    useNavOpen().value = false
})
